


























import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { FalconSortOptions } from "@/interfaces/falcon/shared/falcon-sort-options";

import { SortOrder } from "@/enums/falcon/falcon-sort-order.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon sort form component
 */
@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class SortOptionsForm extends Vue {
  @Prop() setSortOptions!: (sortOptions: FalconSortOptions) => void;

  /** Optional sort type value */
  sortType = 1;

  /** Optional sort direction value */
  sortOrder: SortOrder = SortOrder.Descending;

  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.invokeSortOptionsSetter();
  }

  sortOptionsUpdated(event: Event): void {
    if ((event.target as HTMLElement).tagName.toLowerCase() !== "select") {
      return;
    }
    this.invokeSortOptionsSetter();
  }

  private invokeSortOptionsSetter(): void {
    this.setSortOptions({
      sortType: this.sortType,
      sortOrder: this.sortOrder
    });
  }
}
